import React from 'react'

import Config from '../config'
import FilterBarContainer from '../containers/filter-bar.container'
import ActiveFilterListContainer from '../containers/active-filter-list.container'
import FeaturedResourceContainer from '../containers/featured-resource.container'
import ResourceListContainer from '../containers/resource-list.container'

class ResourceGridApp extends React.Component{
	render(){
		return (
			<div className={ Config.appClass }>
				<FilterBarContainer />
				<ActiveFilterListContainer />
				<FeaturedResourceContainer />
				<ResourceListContainer />
			</div>
		);
	}

	componentDidMount(){
		if(window.grunticon){
			window.grunticon.embedSVG()
		}
	}

	componentDidUpdate() {
		if(window.grunticon){
			window.grunticon.embedSVG()
		}
	}
}

export default ResourceGridApp



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/resource-grid/components/resource-grid.js